import React, {useState} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';

import i18n from '../../i18n';
import FormControl from '@material-ui/core/FormControl';
import FormField from '../../components/Form/FormField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import {urlQuery} from '../Form/utils';

const grid_sm = 12;
const grid_xs = 12;

const doSearch = (baseUrl, params) => {
    window.location.href = baseUrl + (baseUrl.includes('?') ? '&' : '?') + urlQuery(params);
};

const SearchForm = (props) => {
    const [filter, setFilter] = useState(props.filter);
    const classes = props.classes;

    const handleSubmit = (ev) => {
        ev.preventDefault();
        doSearch(props.url, {
            filter,
            ...props.params
        });
    };

    return (
        <form onSubmit={handleSubmit.bind(this)} action={""}>
            <FormControl className={classes.formControl}>
                <Grid container spacing={8}>
                    <Grid item xs={grid_xs} sm={grid_sm} md={6}>
                        <FormField
                            name="filter"
                            label={i18n.get('contacts.search_text')}
                            value={filter || ''}
                            onChange={(e) => {
                                setFilter(e.target.value);
                            }}
                        />
                    </Grid>

                    <Grid item xs={grid_xs} sm={grid_sm} md={1}>
                        <Button type="submit" className={classes.searchButton}
                                onClick={handleSubmit}
                        >
                            <Icon>search</Icon>
                        </Button>
                    </Grid>
                </Grid>
            </FormControl>
        </form>
    );
};

const styles = theme => ({
    searchButton: {
        height: '100%',
    },
    formControl: {
        width: '100%',
        padding: theme.spacing.unit * 2,
    },
});

export default withStyles(styles)(SearchForm);
